import { Button, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { useTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";

export const CopyToClipboardButton = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation(I18N_NS.PROJECT);
  const [icon, setIcon] = useState<IconProp>(["far", "copy"]);

  const handleClick = () => {
    onClick();
    setIcon(["far", "check"]);
    setTimeout(() => {
      setIcon(["far", "copy"]);
    }, 2000);
  };

  return (
    <Tooltip title={t("Copy")}>
      <Button type="text" size="small" onClick={handleClick}>
        <FontAwesomeIcon icon={icon} fixedWidth />
      </Button>
    </Tooltip>
  );
};
